<template>
  <div>
    <b-form-group label="Hide toolbar:">
      <b-form-checkbox v-model="control.hideToolbar">
        {{ control.hideToolbar ? "yes": "no" }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ['control']
}
</script>
